import { createContext, useContext } from 'react';

export const ScreenHostOnboardingContext = createContext(null);

export function useScreenHostOnboarding() {
    const ctx = useContext(ScreenHostOnboardingContext);
    if (!ctx) {
        return {
            loading: false,
            tourActive: false,
            activeStepId: null,
            completedSteps: [],
            showWelcome: false,
            hardwareSetupPreference: null,
            tvAppLinks: {},
            startTour: () => {},
            goToNextStep: () => {},
            skipTour: () => {},
            markStep: async () => {},
            finishTour: async () => {},
            jumpToStep: () => {},
            replayTour: () => {},
            isOnboardingStep: () => false,
        };
    }
    return ctx;
}
